import styled from "styled-components";

const InfoBoxStyled = styled.div`
    .titeContainer {
        padding-bottom: 3rem;
    }
    .title {
        padding-left: 2rem;
    }
    .info-large {
        width: 7rem;
        height: 7rem;
    }
    .pack-explain {
        font-size: 1.2rem;
    }
`;

export default InfoBoxStyled;
